import cx from 'classnames'
import PropTypes from 'prop-types'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-separator`

export const SEPARATOR_SIZES = {
  LARGE: 'large',
  MEDIUM: 'medium'
}

const Separator = ({size = SEPARATOR_SIZES.LARGE}) => {
  const className = cx(BASE_CLASS, {[`${BASE_CLASS}--${size}`]: size})

  return (
    <div className={className}>
      <hr className={`${BASE_CLASS}-line`} />
    </div>
  )
}

Separator.displayName = 'Separator'
Separator.propTypes = {
  size: PropTypes.oneOf(Object.values(SEPARATOR_SIZES))
}

export default Separator
